<template>
  <nav>
    <ul v-if="isWeb" class="web-menu">
      <!-- Menu para web -->
      <li
        :class="{
          active: isRouteActive('/investments/dashboard'),
        }">
        <router-link :to="{ name: 'investmentsDashboard' }">
          <i class="fas fa-home" />
          <!-- Ícone de Dashboard -->
          <span>Dashboard</span>
        </router-link>
      </li>

      <li
        :class="{
          active: isRouteActive('/investments/portfolio'),
        }">
        <router-link :to="{ name: 'portfolio' }">
          <i class="fas fa-wallet" />
          <!-- Ícone de Carteira -->
          <span>Minha carteira</span>
        </router-link>
      </li>

      <!-- Dropdown Aplicações usando PrimeVue -->
      <li :class="{ active: isDropdownActive(applicationsOptions) }" class="dropdown">
        <Dropdown :options="applicationsOptions" option-label="label" placeholder="Aplicações" @change="navigateTo" />
      </li>

      <!-- Dropdown Outros usando PrimeVue -->
      <li :class="{ active: isDropdownActive(othersOptions) }" class="dropdown">
        <Dropdown :options="othersOptions" option-label="label" placeholder="Outros" @change="navigateTo" />
      </li>
    </ul>

    <div v-else class="mobile-menu">
      <!-- Menu para dispositivos móveis -->
      <div class="dropdown d-flex justify-content-between align-items-center">
        <button class="dropdown-toggle" @click="toggleMenu">
          <p>
            {{ selectedMobileRoute ? getPageTitle(selectedMobileRoute) : "Selecione uma opção" }}
          </p>
        </button>
        <ul class="dropdown-menu" :class="{ 'show-menu': isMenuOpen }">
          <li v-for="route in mobileRoutes" :key="route.path" :class="{ active: isRouteActive(route.path) }">
            <router-link :to="route.path" @click="toggleMenu">
              <span>{{ route.title }}</span>
            </router-link>
          </li>
        </ul>
        <span class="eye-icon text-white" @click="showCurrency()">
          <i :class="hideCurrency ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'" />
        </span>
      </div>
    </div>
  </nav>
</template>

<script>
import { useAppStore } from "@/store/store.js";

export default {
  name: "NavMenuInvestments",
  data() {
    return {
      isMenuOpen: false,
      isWeb: false,
      selectedMobileRoute: "",
      applicationsOptions: [
        { label: "Planejamento de carteira", value: "portfolioPlanning", path: "/investments/portfolio-planning" },
        { label: "Evolução de patrimônio", value: "netWorth", path: "/investments/net-worth" },
        { label: "Gestão de ativos", value: "financialManagement", path: "/investments/financial-management" },
        { label: "Rebalanceamento de carteira", value: "rebalance", path: "/investments/rebalance" },
      ],
      othersOptions: [
        { label: "Imposto de renda", value: "incomeTax", path: "/investments/income-tax" },
        { label: "Relatórios", value: "reports", path: "/investments/reports" },
        { label: "Proventos", value: "reports", path: "/investments/dividends" },
      ],
      mobileRoutes: [
        { path: "/investments/dashboard", title: "Dashboard" },
        { path: "/investments/portfolio", title: "Minha carteira" },
        { path: "/investments/portfolio-planning", title: "Planejamento de carteira" },
        { path: "/investments/net-worth", title: "Evolução de patrimônio" },
        { path: "/investments/financial-management", title: "Gestão de ativos" },
        { path: "/investments/dividends", title: "Proventos" },
        { path: "/investments/rebalance", title: "Rebalanceamento de carteira" },
        { path: "/investments/income-tax", title: "Imposto de renda" },
        { path: "/investments/reports", title: "Relatórios" },
      ],
    };
  },
  computed: {
    hideCurrency() {
      const store = useAppStore();
      return store.hideCurrency;
    },
  },
  watch: {
    $route(to, from) {
      this.selectedMobileRoute = to.path;
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
    this.setCurrentRoute();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    showCurrency() {
      const store = useAppStore();
      store.hideCurrency = !store.hideCurrency;
    },
    isRouteActive(route) {
      return this.$route.path === route;
    },
    isDropdownActive(options) {
      return options.some((option) => this.isRouteActive(option.path));
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    checkScreenSize() {
      this.isWeb = window.innerWidth > 767;
    },
    getPageTitle(route) {
      const foundRoute = this.mobileRoutes.find((r) => r.path === route);
      return foundRoute ? foundRoute.title : "";
    },
    setCurrentRoute() {
      this.selectedMobileRoute = this.$route.path;
    },
    navigateTo(event) {
      this.$router.push(event.value.path);
    },
  },
};
</script>

<style lang="scss" scoped>
nav {
  background: #283045 0% 0% no-repeat padding-box;
  border-radius: 7px;
  opacity: 1;
  margin: 20px 0;
  padding: 0 20px;
}
.web-menu {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  gap: 4rem;

  li {
    display: inline-block;
    font-size: 14px;
    color: #fff;

    &.dropdown {
      cursor: pointer;
      position: relative;
    }
  }

  a {
    color: #fff;
    padding: 10px;
    text-decoration: none;
    display: flex;
    align-items: center;

    i {
      margin-right: 10px;
    }
  }

  li.active {
    font-weight: bold;
  }
  .router-link-active {
    background: #f2623669 0% 0% no-repeat padding-box;
    border-radius: 4px;
    color: #fff;

    border-bottom: 4px solid #c65440;
  }
}

.mobile-menu {
  display: none;

  ul {
    background-color: #181d2f;
    border: none;
    box-shadow: 2px 2px 4px 2px rgba(133, 131, 131, 0.2);
  }

  li {
    margin-bottom: 5px;
  }

  a {
    color: #fff;
    padding: 10px;
    text-decoration: none;
  }

  router-link-active {
    background: #f2623669 0% 0% no-repeat padding-box;
    border-radius: 4px;
    color: #fff;
  }
}

.show-menu {
  display: block;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #fff;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  p {
    padding: 10px;
    background: #f2623669 0% 0% no-repeat padding-box;
    border-radius: 4px;
    color: #fff;
    font-weight: bold;
    margin: 0;
  }
}

.arrow-down {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 5px 0 5px;
  border-color: #fff transparent transparent transparent;
  margin-left: 5px;
}
.p-dropdown {
  border: none;
}
.p-inputwrapper-focus {
  border: none;
}

@media (max-width: 767px) {
  .web-menu {
    display: none;
  }

  .mobile-menu {
    display: block;
  }
}

.disabled {
  opacity: 0.4;
}
.link-disabled {
  pointer-events: none;
}

.eye-icon {
  font-size: 21px;
  cursor: pointer;
}
</style>
